export const finnishCountryCodeString = '(\\+|00)358';
export const finnishCountryCode = new RegExp(`^${finnishCountryCodeString}`);
